import DriverManager from '../features/people/DriverManager';

export default function DriversPage() {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Kuryeler</h1>
          <p>Kuryeleri yönetin, müsaitlik durumlarını takip edin ve teslimat performansını izleyin.</p>
        </div>
      </header>
      <section className="page-section">
        <DriverManager />
      </section>
    </div>
  );
}
